import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'
import '../css/header.css'
import { Link } from "react-router-dom"
import { Navbar, Nav } from 'react-bootstrap'

export default function Header() {
    return (
        <Navbar className="sticky-top align-items-end navbar-custom" bg="dark" variant="dark" expand="lg">
            <Navbar.Brand
                className="cursor-pointer"
                onClick={() => {
                    window.scrollTo(0, 0)
                }}>
                <Link to='/'>
                    <img
                        src={require('../media/textlogo_white.png')}
                        width="182"
                        height="70"
                        className="d-inline-block align-top"
                        alt="React Bootstrap logo"
                    />
                </Link>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="ml-auto text-right">
                    {/* <Nav.Link href="#gestaltung">Gestaltung</Nav.Link>
                    <Nav.Link href="#company">Über Uns</Nav.Link> */}
                    <Nav.Link
                        onClick={() => {
                            window.scrollTo({
                                top: document.body.scrollHeight
                            })
                        }}
                        href="#footer-imprint"
                        className="px-sm-0 py-sm-2 py-md-0">
                        Kontakt
                    </Nav.Link>
                </Nav>
            </Navbar.Collapse>
        </Navbar>
    )
}
